import request from '../utils/request'
import { getToken } from '../utils/auth'

export function fetchExhibitionList(filter) {
  return request({
    url: '/api/exhibitions',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function fetchExhibition(id, filter) {
  return request({
    url: '/api/exhibitions/' + id,
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function createExhibition(data) {
  return request({
    url: '/api/exhibitions',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function updateExhibition(id, data) {
  return request({
    url: '/api/exhibitions/' + id,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function createExhibitionLang(data) {
  return request({
    url: '/api/exhibition_langs',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function updateExhibitionLang(id, data) {
  return request({
    url: '/api/exhibition_langs/' + id,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function deleteExhibitionWithCollection(id) {
  return request({
    url: '/api/exhibitions/' + id + '/removeAll',
    method: 'delete',
    params: {
      'access_token': getToken()
    }
  })
}

export function deleteExhibition(id) {
  return request({
    url: '/api/exhibitions/' + id,
    method: 'delete',
    params: {
      'access_token': getToken()
    }
  })
}

export function deleteExhibitionLang(id) {
  return request({
    url: '/api/exhibition_langs/' + id,
    method: 'delete',
    params: {
      'access_token': getToken()
    }
  })
}
